<script lang="ts" setup>
import Shape from "~/components/icon/Shape.vue";

const {collectionUri, pageUri} = useI18nCollection();
const page = await queryCollection(collectionUri('home')).path(pageUri('home/banner-section-cta')).first();
</script>

<template>
  <section class="p-2 tablet:mb-2">
    <div class="bg-brand rounded-img pt-32 pb-6 relative -z-1">
      <div class="page-container tablet:flex tablet:flex-col tablet:justify-end tablet:min-h-[50vh] tablet:pb-32 tablet:pe-[33vw]">
        <strong class="text-secondary uppercase text-sm mb-4 block tablet:mb-12 desktop:mb-16 wide:mb-20">{{
            page.title
          }}</strong>
        <ContentRenderer
                :value="page"
                class="text-white text-3xl/[42px] tablet:text-4xl desktop:text-5xl font-medium strong-spacer"/>
      </div>
      <Shape class="absolute inset-0 m-auto -z-1 opacity-20"/>
    </div>
  </section>
</template>

<style scoped>

</style>